import { LitElement, html, css } from 'lit';
import { customElement } from 'lit/decorators.js';
import { cmdShowComment } from '../commands.js';

@customElement('help-button')
export class HelpButton extends LitElement {
  static styles = css`
    :host {
      position: absolute;
      bottom: env(safe-area-inset-bottom, 12px);
      right: env(safe-area-inset-right, 12px);
      pointer-events: auto;
      cursor: pointer;
    }
    .btn {
      color: #ff0000;
      font-size: 1.8rem;
      font-weight: bold;
      padding: 8px 14px;
    }
  `;

  render() {
    return html`<div class="btn" @click=${cmdShowComment}>?</div>`;
  }
}
